module.exports = "/_next/static/images/you_button-9bf2bdee020cde0bb1e059e40939061c.png";